import { sendBytes } from './byteTransfer'
import { PCVersionCode } from './byteCodes'
import { utf16ToChar } from './utils'
import { resolve } from 'path'

export const getVersion = async (port, flag = false) => {
    await sendBytes(PCVersionCode, port)
    const response = flag
        ? await readForVersion2(port)
        : await readForVersion3(port)

    if (response && response.ok) {
        return response.data
        //     const versionData = flag ? response.data : cleanVersion(response.data)
        //     console.log(versionData)
        //     return versionData
    } else {
        return { Version: '', device: '' }
    }
}

const cleanVersion = (data) => {
    const filterdVersion = utf16ToChar(data).filter(
        (char) => char === '.' || !isNaN(parseInt(char))
    )

    return filterdVersion.join('')
}

const readForVersion = async (port) => {
    if (port === undefined) {
        console.log('Port undefined')
        return
    }

    let combinedResponse = []
    while (port.readable) {
        if (port.readable.locked) return

        let reader = port.readable.getReader()
        let count = 5
        try {
            while (true) {
                console.log('waiting for data ... ')
                const { value } = await reader.read()
            }
        } catch (err) {
            console.log(err)
        } finally {
            reader.releaseLock()
            port.readable.cancel()
            console.log('Reader lock released')
        }
    }
}
const readForVersion2 = async (port) => {
    if (port === undefined) {
        console.log('Port undefined')
        return
    }

    let combinedResponse = []
    while (port.readable) {
        if (port.readable.locked) return

        let reader = port.readable.getReader()
        try {
            while (true) {
                console.log('waiting for data ... ')
                const { value } = await reader.read()
                console.log('[PORT DATA READING]', value)
                const data = Array.from(value)
                combinedResponse = combinedResponse.concat(data)
                // console.log("Received data : " + data);
                console.log('Combined data : ' + combinedResponse)

                return { ok: true, data: combinedResponse }
            }
        } catch (err) {
            console.log(err)
        } finally {
            reader.releaseLock()
            port.readable.cancel()
            console.log('Reader lock released')
        }
    }
}

//continuous reading and check based on version in readBytes
const readForVersion3 = async (port) => {
    if (port === undefined) {
        console.log('Port undefined')
        return
    }
    try {
        const res = await startReading(port)
        console.log('rejected', res)
        return res
    } catch (e) {
        return null
    }
}

const startReading = async (port) => {
    return new Promise(async (resolve, reject) => {
        var reqDataFound = false
        let bytesRead = 0
        let combinedResponse = []
        let isLocked = true
        while (port.readable) {
            console.log('getting reader')
            if (port.readable.locked) return
            var reader = port.readable.getReader()
            try {
                const timeOutPromise = new Promise((_, reject) => {
                    displayMessages(reqDataFound, resolveMessage)
                    setTimeout(() => {
                        console.log('time out')
                        if (bytesRead === 0 || !reqDataFound) {
                            let path = window.location.pathname
                            if (path.includes('deviceSelection'))
                                sendData('unable to connect the device')
                            reject('unable to connect the device')
                            // reject('no data found')
                        }
                    }, 10000)
                })
                var resolveMessage
                const msgPromise = new Promise((resolve) => {
                    resolveMessage = resolve
                })

                await Promise.race([
                    timeOutPromise,
                    Promise.all([msgPromise, readDataBytes()]),
                ])

                async function readDataBytes() {
                    while (true) {
                        const { value } = await reader.read()

                        if (value) {
                            bytesRead = value.length

                            const data = Array.from(value)

                            combinedResponse = combinedResponse.concat(data)
                            let strData = combinedResponse.join(',')
                            let unicode = utf16ToChar(combinedResponse).join('')
                            let regxPC =
                                /(?:PC(?:v?0)\.1\.\d{2}|ZG(?:1\.0\.\d{2}|0\.1\.\d{2})|CW1\.0\.\d{2})/
                            // let regxZG = /ZG(?:1\.0\.\d{2}|0\.1\.\d{2})/

                            const match = unicode.match(regxPC)

                            if (match) {
                                let device = match[0].includes('ZG')
                                    ? 'Humanoid'
                                    : match[0].includes('CW')
                                      ? 'Hexapod'
                                      : 'Ace'
                                let result = match[0].replace(/^[a-zA-Z]+/, '')

                                reqDataFound = true
                                resolve({
                                    ok: true,
                                    data: { Version: result, device },
                                })
                                resolveMessage()
                                break
                            }
                        }
                        await new Promise((resolve, reject) => {
                            setTimeout(resolve, 0)
                        })
                    }
                }
            } catch (e) {
                console.log('error caused', e)
                reject(e)
                break
            } finally {
                await reader.releaseLock()

                port.readable.cancel()
            }
        }
    })
}
//for error msg display if unable to read
const displayMessages = async (statusObj) => {
    // Check if firmware update is in progress
    if (sessionStorage.getItem('firmwareUpdateInProgress') === 'true') {
        console.log(
            'Firmware update in progress, skipping normal connection messages'
        )
        return
    }

    console.log('start message1', statusObj.found)

    // Send first message
    if (!statusObj.found) sendData('device connecting')

    await new Promise((resolve) => setTimeout(resolve, 2000))

    // Check status again before sending second message
    if (statusObj.found) return

    // Check again if firmware update started
    if (sessionStorage.getItem('firmwareUpdateInProgress') === 'true') {
        console.log(
            'Firmware update started, skipping further connection messages'
        )
        return
    }

    console.log('start message2', statusObj.found)
    if (!statusObj.found) sendData('fetching the version')

    await new Promise((resolve) => setTimeout(resolve, 2000))
}
//send the error text to selection screen
const sendData = (text) => {
    // Don't send error messages if firmware update is in progress
    if (sessionStorage.getItem('firmwareUpdateInProgress') === 'true') {
        console.log(
            'Firmware update in progress, skipping error message:',
            text
        )
        return
    }

    const event = new CustomEvent('custom', { detail: text })
    document.dispatchEvent(event)
}
const MICROPYTHON_PREFIXES = {
    PCMP: { device: 'Ace', versionDataKey: 'Playcomputer' },
    ZGMP: { device: 'Humanoid', versionDataKey: 'Zing' },
    CWMP: { device: 'Hexapod', versionDataKey: 'Crawlee' },
    KWMP: { device: 'Klaw', versionDataKey: 'Klaw' },
    RBMP: { device: 'Roboki', versionDataKey: 'Roboki' },
    MKMP: { device: 'Moki', versionDataKey: 'Moki' },
    TKMP: { device: 'Toki', versionDataKey: 'Toki' },
    PKMP: { device: 'Poki', versionDataKey: 'Poki' },
    ATMP: { device: 'Atr', versionDataKey: 'Atr_h2' },
}

const DEVICE_PREFIXES = {
    CW: 'Hexapod',
    ZG: 'Humanoid',
    RB: 'Roboki',
    KW: 'Klaw',
    AT: 'Atr',
    TK: 'Toki',
    PK: 'Poki',
    MK: 'Moki',
    PC: 'Ace',
}

function parseMicroPythonResponse(data) {
    const mpRegex = /([A-Z]{2})MP_(\d+(?:\.\d+)?)/
    const match = data.match(mpRegex)
    if (!match) return null

    const prefix = match[1] + 'MP'
    const seriesVersion = match[2]
    const info = MICROPYTHON_PREFIXES[prefix]
    if (!info) return null

    return {
        device: info.device,
        versionDataKey: info.versionDataKey,
        seriesVersion,
        isMicroPython: true,
    }
}

function parseStandardVersion(data) {
    // Optional trailing segment so a 4-part hotfix version (e.g. RB1.1.7.1) matches in full instead of being cut to 3 parts.
    const regx =
        /(?:(PCv\d+\.\d{1,3}\.\d{2}[ab]?)|(PCv0\.1\.\d{2})|((?:ZG|CW|KW|PC|AT|TK|MK|PK)\d+\.\d{1,3}\.\d{1,3}(?:\.\d{1,3})?)|(RB\d+(?:\.\d{1,3}){2}(?:\.\d{1,3})?))/
    const match = data.match(regx)
    if (!match) return null

    const versionStr = match[0]
    let device = 'Ace'
    for (const [prefix, deviceName] of Object.entries(DEVICE_PREFIXES)) {
        if (versionStr.startsWith(prefix)) {
            device = deviceName
            break
        }
    }
    const version = versionStr.replace(/^[a-zA-Z]+/, '')
    return { device, version, isMicroPython: false, full_version: versionStr }
}

function checkIfMicroPython(worker, versionData) {
    return new Promise(async (resolve, reject) => {
        try {
            worker.onmessage = (e) => {
                if (e.data.type === 'read') {
                    const data = e.data.value
                    const mpResult = parseMicroPythonResponse(data)
                    if (mpResult) {
                        const seriesVersion = mpResult.seriesVersion.includes(
                            '.'
                        )
                            ? mpResult.seriesVersion
                            : mpResult.seriesVersion + '.0'
                        sessionStorage.setItem('microPython', 'true')
                        resolve({
                            Version: seriesVersion,
                            device: mpResult.device,
                        })
                    }
                }
            }
        } catch (e) {
            reject(e.message)
        }
    })
}
export const getS3Version = async (worker, pid) => {
    if (sessionStorage.getItem('firmwareUpdateInProgress') === 'true') {
        console.log('Skipping getS3Version due to firmware update')
        return { Version: 'BOOT_MODE', device: 'Unknown' }
    }
    let versionData = {}
    try {
        versionData = JSON.parse(sessionStorage.getItem('versionData'))
    } catch (e) {
        console.log(e)
    }
    sessionStorage.removeItem('peeCeeConfVersion')

    return new Promise(async (resolve, reject) => {
        let status = { found: false }

        let intervalID = setInterval(() => {
            worker.postMessage({ type: 'write', value: 'WHO' })
        }, 100)

        try {
            let resolveMessageBeta
            const msgPromise = new Promise((resolve) => {
                resolveMessageBeta = resolve
            })

            const timeoutPromise = new Promise((re, reject) => {
                // Pass the status object
                displayMessages(status)

                setTimeout(() => {
                    if (!status.found) {
                        if (pid !== 0x8055) {
                            let path = window.location.pathname
                            if (path.includes('deviceSelection'))
                                sendData('unable to connect the device')
                            clearInterval(intervalID)
                            resolve({ Version: 'no data found', device: '' })
                            worker.onmessage = null
                        } else {
                            clearInterval(intervalID)
                            worker.onmessage = null
                            re({
                                message: 'Time out next check micropython',
                                isCheckNext: true,
                            })
                        }
                    }
                }, 9000)
            })

            let data = await Promise.race([
                timeoutPromise,
                Promise.all([msgPromise, dataListener()]),
            ])

            // displayMessages(reqDataFound, resolveMessageBeta)

            async function dataListener() {
                worker.onmessage = async (e) => {
                    if (e.data.type !== 'read' || !e.data.value) return
                    const responseData = e.data.value

                    const mpResult = parseMicroPythonResponse(responseData)
                    if (mpResult) {
                        status.found = true
                        const seriesVersion = mpResult.seriesVersion.includes(
                            '.'
                        )
                            ? mpResult.seriesVersion
                            : mpResult.seriesVersion + '.0'
                        sessionStorage.setItem('microPython', 'true')
                        clearInterval(intervalID)
                        resolve({
                            Version: seriesVersion,
                            device: mpResult.device,
                            full_version:
                                responseData.match(
                                    /[A-Z]{2}MP_\d+(?:\.\d+)?/
                                )?.[0] || '',
                        })
                        resolveMessageBeta()
                        setTimeout(() => {
                            worker.onmessage = null
                        }, 1500)
                        return
                    }

                    const stdResult = parseStandardVersion(responseData)
                    if (stdResult) {
                        status.found = true
                        sessionStorage.setItem('microPython', 'false')
                        clearInterval(intervalID)
                        resolve({
                            Version: stdResult.version,
                            device: stdResult.device,
                            full_version: stdResult.full_version,
                        })
                        resolveMessageBeta()
                        setTimeout(() => {
                            worker.onmessage = null
                        }, 1500)
                        return
                    }
                }
            }
            if (pid == 0x8055 && data?.isCheckNext) {
                let who_id = setInterval(async () => {
                    worker.postMessage({
                        type: 'writeArray',
                        value: [0x03, 0x04],
                    })
                }, 500)
                try {
                    const result = await Promise.race([
                        checkIfMicroPython(worker, versionData),
                        new Promise((_, reject) => {
                            setTimeout(() => {
                                clearInterval(who_id)
                                reject('timeout')
                            }, 5000)
                        }),
                    ])
                    // If checkIfMicroPython resolves first, return its result
                    if (result && result.Version) {
                        status.found = true
                        resolve(result)
                        clearInterval(who_id)
                        resolveMessageBeta()
                        worker.onmessage = null
                    } else {
                        let path = window.location.pathname
                        if (path.includes('deviceSelection'))
                            sendData('unable to connect the device')
                        resolve({ Version: 'no data found', device: '' })
                    }
                    // Otherwise continue execution below
                } catch (e) {
                    let path = window.location.pathname
                    if (path.includes('deviceSelection'))
                        sendData('unable to connect the device')
                    resolve({ Version: 'no data found', device: '' })
                    console.log(e)
                    reject(e)
                    // Continue with regular version check below
                }
            }
        } catch (e) {
            let path = window.location.pathname
            if (path.includes('deviceSelection'))
                sendData('unable to connect the device')
            resolve({ Version: 'no data found', device: '' })
            reject(e)
        }
    })
}
